var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 .5a3.941 3.941 0 0 0-3.938 3.938c0 1.78 2.563 4.968 3.532 6.156a.547.547 0 0 0 .781 0c.969-1.188 3.563-4.375 3.563-6.156C12.938 2.28 11.155.5 9 .5Zm0 5.25c-.75 0-1.313-.563-1.313-1.313A1.3 1.3 0 0 1 9 3.125a1.32 1.32 0 0 1 1.313 1.313A1.3 1.3 0 0 1 9 5.75ZM.625 7.25A1.023 1.023 0 0 0 0 8.188V16c0 .375.344.625.656.469L5 14.5V7.219c-.281-.5-.531-.969-.688-1.438L.626 7.25ZM9 11.75c-.469 0-.875-.188-1.156-.531C7.219 10.5 6.562 9.688 6 8.813V14.5l6 2V8.812a25.723 25.723 0 0 1-1.875 2.407A1.437 1.437 0 0 1 9 11.75Zm8.313-6.188L13 7.5v9l4.344-1.719c.375-.156.656-.531.656-.937V6.03c0-.375-.375-.625-.688-.468Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlace);
export default __webpack_public_path__ + "static/media/place.785603aa1cedc3a9548e21d90fb48ebf.svg";
export { ForwardRef as ReactComponent };